"use client"

import { SystemUsersPage } from "../../../modules/admin/system-users"

interface SystemUsersProps {
  sidebarOpen?: boolean
}

export default function SystemUsers({ sidebarOpen }: SystemUsersProps) {
  return (
    <div
      className={`w-full mb-6 p-4 lg:p-6 overflow-x-hidden ${!sidebarOpen ? "max-w-none" : "max-w-7xl mx-auto"}`}
    >
      <SystemUsersPage />
    </div>
  )
}

